
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  Settings, 
  FileText, 
  Bell,
  FileVideo,
  Server,
  LogOut,
  Database,
  ShieldCheck
} from "lucide-react";
import { Logo } from "@/components/ui/logo";

export const AdminSidebar = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const tabParam = urlParams.get("tab");
  
  const menuItems = [
    { 
      icon: <LayoutDashboard size={20} />, 
      label: "Dashboard", 
      path: "/admin", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && (!tabParam || tabParam === "dashboard")
    },
    { 
      icon: <Database size={20} />, 
      label: "Benutzerverwaltung", 
      path: "/admin?tab=users", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && tabParam === "users"
    },
    { 
      icon: <FileText size={20} />, 
      label: "Meta Konten", 
      path: "/admin?tab=meta", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && tabParam === "meta"
    },
    { 
      icon: <FileVideo size={20} />, 
      label: "Tutorials verwalten", 
      path: "/admin?tab=tutorials", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && tabParam === "tutorials"
    },
    { 
      icon: <Server size={20} />, 
      label: "System", 
      path: "/admin?tab=system", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && tabParam === "system" 
    },
    { 
      icon: <ShieldCheck size={20} />, 
      label: "Sicherheit", 
      path: "/admin?tab=security", 
      active: (location.pathname === "/admin" || location.pathname === "/admin/dashboard") && tabParam === "security" 
    },
    { 
      icon: <Bell size={20} />, 
      label: "Benachrichtigungen", 
      path: "/admin/notifications", 
      active: location.pathname === "/admin/notifications" 
    },
  ];

  return (
    <div className="w-64 h-full bg-gradient-radial from-[#1c242f] to-[#0f121a] border-r border-gray-800/30 backdrop-blur-sm shadow-xl">
      <div className="flex flex-col h-full">
        <div className="p-4 pb-2 flex flex-col items-center border-b border-gray-800/30">
          <div className="mb-2 w-full flex justify-center">
            <Logo size="xl" isWhite={true} />
          </div>
          <p className="text-sm text-[#41c7f0] tracking-wider mt-0 opacity-90">ADMIN</p>
        </div>

        <nav className="flex-1 py-2">
          <ul className="space-y-1">
            {menuItems.map((item, index) => (
              <li key={index} className="px-3">
                <Link
                  to={item.path}
                  className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
                    item.active 
                      ? "bg-[#263747] text-white border-l-2 border-[#41c7f0] shadow-md" 
                      : "text-white/90 hover:bg-[#2e3d4d] hover:text-[#ffffffcc]"
                  }`}
                >
                  <span className={`mr-3 ${item.active ? "text-white" : "text-white/90"}`}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-800/30 mt-auto">
          <Link
            to="/logout"
            className="flex items-center px-4 py-3 text-white/80 hover:bg-[#2e3d4d] hover:text-[#ffffffcc] rounded-lg transition-all duration-200"
          >
            <LogOut size={20} className="mr-3" />
            <span>Abmelden</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
